export const AUSTRALIAN_STATES = [
    { text: 'New South Wales', value: 'NSW' },
    { text: 'Victoria', value: 'VIC' },
    { text: 'Australian Capital Territory', value: 'ACT' },
    { text: 'Northern Territory', value: 'NT' },
    { text: 'Queensland', value: 'QLD' },
    { text: 'South Australia', value: 'SA' },
    { text: 'Tasmania', value: 'TAS' },
    { text: 'Western Australia', value: 'WA' },
];

export const enum Market {
    GB = 'gb',
    ZA = 'za',
    AU = 'au',
    CA = 'ca',
    NZ = 'nz',
    GLOBAL = 'global',
}

export const GB = 'gb';
export const ZA = 'za';
export const AU = 'au';
export const CA = 'ca';
export const NZ = 'nz';
export const GLOBAL = 'global';

export const MARKETS = [GB, ZA, AU, CA, NZ] as const;

export type Markets = typeof MARKETS;

export const IN_STATES = [];
